import React, { Component } from 'react';
import { Form, Input, Icon, Select, Upload, Button, message } from 'antd';
import { connect } from 'react-redux';

import { API_URL } from '../../../../../../utils/constants';

const FormItem = Form.Item;

const deptList = ['Quản trị tác nghiệp', 'Quản trị chiến lược', 'Cơ sở', 'Marketing'];

const UserEditorForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },

  mapPropsToFields(props) {
    return {
      newLecturerId: Form.createFormField({
        ...props.newLecturerId,
        value: props.newLecturerId.value,
      }),
      newPassword: Form.createFormField({
        ...props.newPassword,
        value: props.newPassword.value,
      }),
      newFullname: Form.createFormField({
        ...props.newFullname,
        value: props.newFullname.value,
      }),
      newPosition: Form.createFormField({
        ...props.newPosition,
        value: props.newPosition.value,
      }),
      // newPhone: Form.createFormField({
      //   ...props.newPhone,
      //   value: props.newPhone.value,
      // }),
      // newResearchField: Form.createFormField({
      //   ...props.newResearchField,
      //   value: props.newResearchField.value,
      // }),
      newDepartment: Form.createFormField({
        ...props.newDepartment,
        value: props.newDepartment.value,
      }),
      newDegree: Form.createFormField({
        ...props.newDegree,
        value: props.newDegree.value,
      }),
      newAcademicRank: Form.createFormField({
        ...props.newAcademicRank,
        value: props.newAcademicRank.value,
      }),
      newFileUrl: Form.createFormField({
        ...props.newFileUrl,
        value: props.newFileUrl.value,
      }),
      newFileName: Form.createFormField({
        ...props.newFileName,
        value: props.newFileName.value,
      }),
      // newEmail: Form.createFormField({
      //   ...props.newEmail,
      //   value: props.newEmail.value,
      // }),
    };
  },

  // onValuesChange(_, values) {
  //   console.log(values);
  // },
})(class extends Component {
  state = {
    passwordVisible: false,
    fileList: [],
  };

  componentDidMount() {
    const { newFileUrl, newFileName } = this.props;
    if (newFileUrl.value && newFileName.value) {
      this.setState({
        fileList: [{
          uid: Date.now(),
          name: newFileName.value,
          status: 'done',
          url: newFileUrl.value,
        }],
      });
    }
  }

  passwordVisibilityChange = () => {
    this.setState({ passwordVisible: !this.state.passwordVisible });
  }

  handleDeptChange = value => {
    this.props.onChange({ newDepartment: { value } });
  }

  handleUploadFile = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({
        fileList: [{
          uid: info.file.uid,
          name: info.file.originFileObj ? info.file.originFileObj.name : info.file.name,
          status: info.file.status,
          url: '',
        }],
      });
      this.props.onChange({ newFileUrl: { value: '' }, newFileName: { value: '' } });
    } else if (info.file.status === 'done' && info.file) {
      this.setState({
        fileList: [{
          uid: info.file.response._id,
          name: info.file.response.originalname,
          status: info.file.status,
          url: info.file.response.location,
        }],
      });
      this.props.onChange({ newFileUrl: { value: info.file.response.location }, newFileName: { value: info.file.response.originalname } });
      message.success(`Tệp ${info.file.response.originalname} được tải lên thành công.`);
    } else if (info.file.status === 'error') {
      message.error('Tải lên thất bại.');
    } else if (info.file.status === 'removed') {
      this.setState({
        fileList: [],
      });
      this.props.onChange({ newFileUrl: { value: '' }, newFileName: { value: '' } });
    }
  }

  render() {
    const { form: { getFieldDecorator }, newDepartment, userInfo } = this.props;
    const { passwordVisible } = this.state;
    const passwordSuffix = <Icon type={passwordVisible ? 'eye-o' : 'eye'} onClick={this.passwordVisibilityChange} />;
    const props = {
      name: 'file',
      action: `${API_URL}/upload/`,
      headers: {
        Authorization: userInfo.token,
      },
      multiple: true,
      onChange: this.handleUploadFile,
    };

    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem
          {...this.props.formItemLayout}
          label="Mã người dùng"
        >
          {getFieldDecorator('newLecturerId')(
            <Input
              placeholder="Mã người dùng không được để trống"
            />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Mật khẩu"
        >
          {getFieldDecorator('newPassword')(
            <Input
              placeholder={this.props.isCreate ? 'Mật khẩu không được để trống' : 'Để trống nếu không muốn thay đổi'}
              type={passwordVisible ? 'text' : 'password'}
              suffix={passwordSuffix}
            />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Họ và tên"
        >
          {getFieldDecorator('newFullname')(
            <Input
              placeholder="Họ và tên không được để trống"
            />
          )}
        </FormItem>
        {/* <FormItem
          {...this.props.formItemLayout}
          label="Email"
        >
          {getFieldDecorator('newEmail')(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Số điện thoại"
        >
          {getFieldDecorator('newPhone')(
            <Input
              placeholder="Số điện thoại"
            />
          )}
        </FormItem> */}
        {/* <FormItem
          {...this.props.formItemLayout}
          label="Chức danh"
        >
          {getFieldDecorator('newPosition')(
            <Input />
          )}
        </FormItem>
        <Form.Item
          {...this.props.formItemLayout}
          label="Bộ môn"
        >
          <Select
            style={{ width: '100%' }}
            defaultValue={deptList[newDepartment.value - 1]}
            onChange={this.handleDeptChange}
          >
            {deptList.map(r => <Select.Option key={r} value={deptList.indexOf(r) + 1}>{r}</Select.Option>)}
          </Select>
        </Form.Item>
        <FormItem
          {...this.props.formItemLayout}
          label="Học vị"
        >
          {getFieldDecorator('newDegree')(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Học hàm"
        >
          {getFieldDecorator('newAcademicRank')(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...this.props.formItemLayout}
          label="Tệp PDF"
        >
          <Upload
            fileList={this.state.fileList}
            {...props}
          >
            <Button>
              <Icon type="upload" /> Tải lên
            </Button>
          </Upload>
        </FormItem> */}
        {/* <FormItem
          {...this.props.formItemLayout}
          label="Hướng nghiên cứu"
        >
          {getFieldDecorator('newResearchField')(
            <Input />
          )}
        </FormItem> */}
      </Form>
    );
  }
});

export default connect(state => ({
  userInfo: state.user.info,
}))(UserEditorForm);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/Users/UserEditor/UserEditorForm.js